<template>
  <v-dialog
    transition="dialog-bottom-transition"
    max-width="1200"
    v-model="dialog"
  >
    <template v-slot:default="dialog">
      <v-card>
        <v-toolbar
          color="primary"
          dark
        >

          <v-btn
            @click="handleClose(false)"
            style="margin-right: 20px;"
          >Cerrar</v-btn>
        </v-toolbar>
        <v-card-text style="padding-top: 10px;">
          <v-card style="padding: 5px;">
            <v-text-field
              v-model="edited"
              solo
              name="input-7-4"
              label="Incremental"
              hide-details
            />
            <v-btn
              @click="handleSave"
              block
              style="margin-top: 5px;"
            >Guardar</v-btn>
          </v-card>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            text
            @click="handleClose(false)"
          >Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>
<script>
import axios from 'axios'
export default {
  props: {
    apiURL: {
      type: String,
      required: true,
    },
    device: {
      type: Object,
      default: null,
    },
    onClose: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    dialog: false,
    edited: null,
  }),
  watch: {
    device (v) {
      this.edited = null
      this.dialog = v ? true : false
    },
    'device.ID' (v) {
      this.edited = null
      this.dialog = v ? true : false
    },
    dialog (v) {
      if (v) this.handlePrepareData()
    }
  },
  methods:{
    handleClose (refresh) {
      this.onClose(refresh)
    },
    handlePrepareData () {
      this.edited = this.device.Incremental ? this.device.Incremental.toString() : null
    },
    handleSave () {
      if (!this.edited && this.edited.length === 0) {
        alert('No encontrad0')
        return
      }
      const body = JSON.parse(JSON.stringify(this.device))
      body.Incremental = this.edited
      axios.patch(`${this.apiURL}/v1/private/brightsign/${this.device.Network}/devices/${this.device.ID}?token=${localStorage.getItem('jwt')}`, body)
        .then (() => {
          this.handleClose(true)
        })
        .catch (error => {
          console.log(error)
          alert('Error')
        })
    },
  },
}
</script>

